import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store';

export function EmployeeOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const userType = (user as any)?.userType as string | undefined;

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (userType === 'ADMIN')          return <Navigate to="/dashboard" replace />;
  if (userType === 'PRACTITIONER')   return <Navigate to="/practitioner/dashboard" replace />;

  return <>{children}</>;
}

export default EmployeeOnlyRoute;
